import { isFunction } from "lodash";
import { t } from "@/i18n-js/instance";
import { DaysFilter, Filter } from "@circle-react-shared/Filter";
import type { DaysAgoFormOption } from "../../Filter/FilterTypes/DaysFilter";
import { renderSelectedOption } from "../../Filter/FilterTypes/DaysFilter";
import type { BaseFilter } from "../types";

const localeNamespace = "members_directory.header.search.filters";

const options: DaysAgoFormOption[] = [
  {
    label: t([localeNamespace, "days_ago.lt"]),
    value: "lt",
  },
  {
    label: t([localeNamespace, "days_ago.eq"]),
    value: "eq",
  },
  {
    label: t([localeNamespace, "days_ago.gt"]),
    value: "gt",
  },
];

interface JoinedCommunityDaysAgoFilterProps {
  isInitialOpen?: boolean;
  onApply?: (value: DaysAgoFormOption) => void;
  param: BaseFilter;
}

export const renderJoinedCommunityDaysAgoLabel = renderSelectedOption(options);

export const JoinedCommunityDaysAgoFilter = ({
  isInitialOpen,
  onApply,
  param,
}: JoinedCommunityDaysAgoFilterProps) => (
  <Filter
    chip={t([localeNamespace, "joined_community_days_ago"])}
    title={t([localeNamespace, "joined_community_days_ago"])}
    selectedText={param.value}
    isInitialOpen={isInitialOpen}
    renderSelectedText={() => renderJoinedCommunityDaysAgoLabel(param)}
    onApply={value => {
      if (isFunction(onApply)) {
        onApply(value);
      }
    }}
    shouldShowRemoveButton
  >
    <DaysFilter options={options} param={param} />
  </Filter>
);
